import { cgiService, getCollection, collectionService } from '@tencent/wuji-source';
import { registerMiddleware } from '@tencent/wuji-data-web';
export const source = {
    use: (middleware, type) => {
        cgiService.registerMiddleware.call(cgiService, middleware, type);
        // AI页面兼容请求中间件
        registerMiddleware(middleware, type);
    },
    getCollection,
    collectionService,
};
export function initGlobalContext(router) {
    const ctx = {
        router,
        source,
    };
    // @ts-ignore
    if (!window.globalContext) {
        Object.defineProperty(window, 'globalContext', {
            get() {
                return ctx;
            },
            enumerable: true,
            configurable: false,
        });
    }
    const event = new Event('wuji:beforeReady', { bubbles: false, cancelable: false });
    document.dispatchEvent(event);
}
